import moment from "moment";

export const displayDateTime = (
  date: Date | string,
  formatDate: string = "ddd D MMM YYYY"
): string => {
  const lastUpdateTimestamp = new Date(date).getTime();

  const currentTimestamp = new Date().getTime();

  const timeDifference = currentTimestamp - lastUpdateTimestamp;

  if (timeDifference < 60 * 1000) {
    // Calculate the number of seconds
    const secondsDifference = Math.floor(timeDifference / 1000);

    if (secondsDifference == 1) {
      return `${secondsDifference} second ago`;
    } else if (secondsDifference == 0) {  
      return `Just now`;
    }

    // Display the seconds
    return `${secondsDifference}s ago`;
  } else if (timeDifference < 60 * 60 * 1000) {
    // Calculate the number of minutes
    const minutesDifference = Math.floor(timeDifference / (60 * 1000));

    // Display the minutes
    return `${minutesDifference} mins ago`;
  } else if (timeDifference < 24 * 60 * 60 * 1000) {
    // Calculate the number of hours
    const hoursDifference = Math.floor(timeDifference / (60 * 60 * 1000));

    return `${hoursDifference} hrs ago`;
  } else if (timeDifference < 7 * 24 * 60 * 60 * 1000) {
    // Calculate the number of days
    const daysDifference = Math.floor(timeDifference / (24 * 60 * 60 * 1000));
    if (daysDifference == 1) {
      return `${daysDifference} day ago`;
    }
    return `${daysDifference} days ago`;
  } else {
    moment.locale('fr');
    const formattedDate = moment(date).format(formatDate);
    return formattedDate;
  }
};
